import React, { createContext, useContext, useRef } from "react";

const ScrollContext = createContext({
  scrollPosition: 0, // Valeur par défaut
  setScrollPosition: () => {}, // Fonction par défaut qui ne fait rien
});

export const useScroll = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useScroll must be used within a ScrollProvider");
  }
  return context;
};

export function ScrollProvider({ children }) {
  const sectionsRef = useRef({});

  const registerSection = (id, ref) => {
    sectionsRef.current[id] = ref;
  };

  const scrollToSection = (id) => {
    const section = sectionsRef.current[id];
    if (section?.current) {
      section.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <ScrollContext.Provider value={{ registerSection, scrollToSection }}>
      {children}
    </ScrollContext.Provider>
  );
}
